import * as angular from "angular";
import {IQService} from "angular";
import {BringozLoaderService} from "../../commons/services/bringoz-loader.service";
import {SkillsAlerts} from "./skills-alerts.service";
import {SkillsRequests} from "./skills-requests.service";

export class SkillsService {

  /* @ngInject */
  constructor(private skillsRequests: SkillsRequests, private skillsAlerts: SkillsAlerts, private $q: IQService, private bringozLoaderService: BringozLoaderService, private $log) {
  }

  getAll() {
    const deferred = this.$q.defer();

    this.skillsRequests.getAll()
      .then((createdSkill) => {
        deferred.resolve(createdSkill)
      })
      .catch((error) => {
        this.$log.error(error);
        this.skillsAlerts.getAllError();
        deferred.reject(error)
      });

    return deferred.promise
  }

  createOne(skill) {
    const deferred = this.$q.defer();
    this.bringozLoaderService.on();
    this.skillsRequests.createOne(skill)
      .then((createdSkill) => {
        this.skillsAlerts.createSuccess();
        deferred.resolve(createdSkill)
      })
      .catch((error) => {
        this.$log.error(error);
        this.skillsAlerts.createError();
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise
  }

  updateOne(skill) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.skillsRequests.updateOne(skill)
      .then((updatedSkill) => {
        this.skillsAlerts.updateOneSuccess(updatedSkill);
        deferred.resolve(updatedSkill)
      })
      .catch((error) => {
        this.$log.error(error);
        this.skillsAlerts.updateOneError();
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise
  }

  updateActiveOne(skill) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.skillsRequests.updateOne(skill)
      .then((updatedSkill) => {
        this.skillsAlerts.updateActiveOneSuccess(updatedSkill);
        deferred.resolve(updatedSkill)
      })
      .catch((error) => {
        this.$log.error(error);
        this.skillsAlerts.updateActiveOneError(skill.active);
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise
  }

}

angular
  .module('bringoz.admin.skills')
  .service('skillsService', SkillsService);
